import { useEffect } from "react";
import CollapseTable from "../../components/tables/CollapseTable";
import { useCategories } from "../../hooks/useCategories";
import { topCategoryQuery } from "../../constants/api";
import { useAppContext } from "../../context/useAppContext";
import { useFirebase } from "../../hooks/firebase/useFirebase";

export const CategoriesRegister = () => {
  const {
    categoriesTableColumns,
    categoriesTableData,
    // getTopMenu,
    // topMenu,
    loading,
  } = useCategories();

  const { contextData } = useAppContext();
  const { topMenu } = contextData;

  return (
    <div>
      <CollapseTable
        loading={loading}
        expandable
        columns={categoriesTableColumns()}
        rows={categoriesTableData(topMenu)}
      />
    </div>
  );
};
